// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__D8sjW","header":"style_header__P-l6m","manager":"style_manager__4ja1V","bg_main":"style_bg_main__eA4PG","bg_top":"style_bg_top__+XlEi"};